import type { ReminderItem } from "../hooks/useVisits.js";
import type { UserRoleAssignment } from "../hooks/useAuth.js";

/**
 * Darf für diese Erinnerungszeile eine Ausnahme beantragt werden?
 * Nur mit Besuchsfrequenz und ohne offenen Antrag (auch keine offene
 * Verlängerung). Neben einer gültigen Ausnahme nur im letzten Monat vor
 * Ablauf — das ist die Verlängerung (Spec Regel 6); diese Lage erkennt die
 * Zeile am Hinweis `laeuft_ab`, den der Server mit derselben Grenze setzt.
 */
export function darfAusnahmeBeantragen(
  item: Pick<ReminderItem, "frequencyMonths" | "hint" | "exemption" | "renewal">,
): boolean {
  if (item.frequencyMonths === null) return false;
  if (item.exemption?.status === "requested" || item.renewal !== null) return false;
  return item.exemption === null || item.hint === "laeuft_ab";
}

/** Bereichsleitung/Stellvertretung genau dieses Segments oder Admin. */
export function fuehrtSegment(roles: UserRoleAssignment[], segmentId: string): boolean {
  return roles.some(
    (r) =>
      r.role === "admin" ||
      ((r.role === "bereichsleiter" || r.role === "stellvertreter") && r.segmentId === segmentId),
  );
}

/**
 * Darf die Rolle überhaupt beantragen? Führung des Segments, Admin oder
 * Projektleitung (ob sie Lead genau dieser Zelle ist, prüft der Server).
 * Nur Geschäftsleitung reicht nicht — sie bekäme 403.
 */
export function rolleDarfBeantragen(roles: UserRoleAssignment[], segmentId: string): boolean {
  return fuehrtSegment(roles, segmentId) || roles.some((r) => r.role === "projektleiter");
}
